import { Routes } from '@angular/router';
import { DS_ONLUYEN_ROUTES } from '@digital-school/ds-onluyen-lib';
import { authGuard } from './guards/auth.guard';
import { LOGIN_ROUTE } from './modules/login/login.routes';

export const APP_ROUTES: Routes = [
  LOGIN_ROUTE,
  ...DS_ONLUYEN_ROUTES.map((route) => ({
    ...route,
    canMatch: [...(route.canMatch ?? []), authGuard],
  })),
];
